import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={101}
    height={props.width? `calc( ${props.width}/ 101 * 101 )`: 101}
    viewBox="0 0 101 101"
    fill="none"
    {...props}
  >
    <path
      fill="url(#acv)"
      stroke="#FF7272"
      d="M74.745 7.266 99.471 50.5 74.745 93.734H25.301L.577 50.5 25.302 7.266h49.443Z"
    />
    <path
      fill="#FF7272"
      fillOpacity={0.2}
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m50.002 17-19.673 7.238L19.86 42.562 23.498 63.4 39.533 77h20.934l16.038-13.6 3.635-20.838-10.469-18.324L50.001 17Z"
    />
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m24 63 26-45 26 45"
    />
    <path
      fill="#fff"
      d="M50.002 57 52 31h-4l2.002 26ZM50.001 64.507c.958 0 1.735-.785 1.735-1.754 0-.968-.777-1.753-1.735-1.753-.958 0-1.734.785-1.734 1.753 0 .969.776 1.754 1.734 1.754Z"
    />
    <defs>
      <radialGradient
        id="acv"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-50.0236 0 0 -50.5 50.023 50.5)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7272" stopOpacity={0.5} />
        <stop offset={1} stopColor="#FF7272" stopOpacity={0} />
      </radialGradient>
    </defs>
  </svg>
)
export default SvgComponent
